import { mount } from 'svelte'
import '@fontsource-variable/figtree'
import '@fontsource-variable/bricolage-grotesque'
import '@fontsource-variable/jetbrains-mono'
import './app.css'
import App from './App.svelte'

const target = document.getElementById('app')
if (!target) {
  throw new Error('#app is missing from index.html')
}

const app = mount(App, { target })

export default app
